import React from "react";
import { generateIndustryLabel } from "../../functions/industry-label";

class GalleryItem extends React.Component{
    constructor(props) {
        super(props)
        this.state = { imgError: false };
        this.imgRef = null;
        this.item = this.props.item;
        let baseImageUrl = this.props.baseImageUrl;
        this.originalSrc = baseImageUrl + "/" + this.item.image;
        this.src = baseImageUrl + "/" + this.item.image;
        this.src2 = null;
        let altImages = this.item.altImages;
        if (altImages && altImages.length) {
            if (altImages[1]) this.src2 = baseImageUrl + "/" + altImages[1];
        }

    }

    componentDidMount() {
        if (this.imgRef && this.imgRef.complete && this.imgRef.naturalHeight === 0) {
            this.handleImageError();
        }
    }

    handleImageError = () => {
        // Hover-image 404 — revert to main and disable hover so we don't get
        // stuck on the placeholder. Stale alt-image references can sneak into
        // the cache between DataSync runs.
        if (this.src2 && this.src === this.src2) {
            this.src2 = null;
            this.src = this.originalSrc;
            this.altImgCss = '';
            this.forceUpdate();
            return;
        }
        this.setState({ imgError: true });
    }

    onMouseEnter = (event) => {
        if (this.src2) {
            this.src = this.src2;
            this.altImgCss='hover';
            this.forceUpdate();
        }
    }

    onMouseLeave = (event) => {
        this.src = this.originalSrc;
        this.altImgCss='';
        this.forceUpdate();
    }

    render(){
        const { item, baseImageUrl } = this.props;
        const { imgError } = this.state;
        let altImageCss=this.altImgCss || '';
        let detailUrl='';
        if(this.props.location){
            // Slugify the name. Fall back to SKU when name is blank — a few
            // clearance items in Dataverse have no PROD_NAME and the empty
            // slug produces a "//" URL that 404s on the MVC route.
            let raw = (item.name || '').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
            let name = raw || item.sku;
            detailUrl=`${this.props.location}/Detail/${name}/${item.sku}`;
        }
        let industriesLabel = generateIndustryLabel(item.industries);
        return(
            <gallery-item>
                {item.badge && <div className="gallery-item-badge">{item.badge}</div>}
                <a href={detailUrl} className="image-container" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    {!imgError ? (
                        <img ref={el => this.imgRef = el} src={this.src} alt={item.name} className={`lazy-image gallery-item-image ${altImageCss}`} onError={this.handleImageError} />
                    ) : (
                        <div className="gallery-item-placeholder"><image-placeholder></image-placeholder></div>
                    )}
                </a>
                <a href={detailUrl} className="gallery-item-info">
                    {item.collection && <span className="gallery-item-collection">{item.collection}</span> }
                    <span className="gallery-item-title">{item.name}</span>
                    {item.extDescription && <span className="gallery-item-description">{item.extDescription}</span>}
                    <span className="gallery-item-sku">{item.sku}</span>
                    {industriesLabel && <span className="gallery-item-grade">{industriesLabel}</span>}
                    {item.price && this.props.isSignedIn && (
                        item.clearancePrice ? (
                            <span className="gallery-item-price">
                                <span className="price-original">From {item.price}</span>
                                <span className="price-clearance">{item.clearancePrice}</span>
                            </span>
                        ) : (
                            <span className="gallery-item-price">From {item.price} <span className="price-msrp">(MSRP)</span></span>
                        )
                    )}
                    <div className="gallery-item-like"> 
                        <img src="/images/icons/heart-icon.png" alt="Like" onClick={(e)=>this.props.onLike(e,item)} />
                    </div>
                </a>
            </gallery-item>
        );
    }

}

export class ShoppingGallery extends React.Component{
    constructor(props) {
        super(props)
    }

    get items(){
        let data=this.props.data;
        return data.map((item)=>{
           return <GalleryItem key={item.id} item={item} baseImageUrl={this.props.baseImageUrl} onLike={this.props.onLike} location={this.props.location} isSignedIn={this.props.isSignedIn} />
        });
    }

    render(){
        return(
            <shopping-gallery>
                {this.items}
            </shopping-gallery>
        );

    }
}